// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4e1b8523","498":"82956749","703":"97036119"}[chunkId] + ".chunk.js";
};